import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BannerId } from '../../typings/banners';
import { PcodeRenderData } from '../../typings/pcode';
import { PcodePreview } from '../PcodePreview/PcodePreview';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './BannerPcodePreviewCell.css';
import * as keyset from './BannerPcodePreviewCell.i18n';

const i18n = i18nFactory(keyset);

interface BannerPcodePreviewCellProps {
    data: PcodeRenderData;
    onClick?: () => void;
    id: BannerId;
}

const BLOCK = 'pcode-preview';

export class BannerPcodePreviewCell extends React.Component<
    BannerPcodePreviewCellProps
> {
    render() {
        const { data, onClick, id } = this.props;

        return (
            <>
                <div className={Bem.cls(BLOCK)} onClick={onClick}>
                    <PcodePreview
                        cls={Bem.cls(BLOCK, 'preview-node')}
                        data={data}
                    />
                    {onClick && (
                        <div className={Bem.cls(BLOCK, 'overlay')}>
                            <Shape2
                                width={32}
                                height={32}
                                icon={Shape2Icon.eye}
                                tone={Shape2Tone.white}
                            />
                        </div>
                    )}
                </div>
                <div className={Bem.cls(BLOCK, 'id')}>
                    {i18n('banner-id', { id })}
                </div>
            </>
        );
    }
}
